import React from "react";

interface LiveViewPageSkeletonProps {
  count?: number;
  columns?: number;
}

export default function LiveViewPageSkeleton({
  count = 9,
  columns = 3,
}: LiveViewPageSkeletonProps) {
  return (
    <div
      className="grid gap-4"
      style={{
        gridTemplateColumns: `repeat(${columns}, minmax(0,1fr))`,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="
            relative
            overflow-hidden
            rounded-2xl
            border
            border-[rgb(var(--border-primary))]
            bg-[rgb(var(--surface-1))]
          "
        >
          {/* Shimmer */}
          <div
            className="
              absolute
              inset-0
              -translate-x-full
              animate-[liveShimmer_2.2s_infinite]
              pointer-events-none
            "
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(255,255,255,0.035), transparent)",
            }}
          />

          {/* Fake Video Area */}
          <div
            className="
              relative
              h-[220px]
              bg-[rgb(var(--surface-2))]
            "
          >
            {/* Live Badge */}
            <div className="absolute top-3 left-3">
              <div
                className="
                  h-5
                  w-14
                  rounded-md
                  bg-[rgb(var(--surface-3))]
                "
              />
            </div>

            {/* Fisheye */}
            <div className="absolute top-3 right-3">
              <div
                className="
                  h-8
                  w-8
                  rounded-full
                  bg-[rgb(var(--surface-3))]
                "
              />
            </div>

            {/* Center loader */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="
                  relative
                  h-14
                  w-14
                  rounded-full
                  border
                  border-[rgb(var(--border-secondary))]
                  bg-[rgb(var(--surface-3))]
                "
              >
                <div
                  className="
                    absolute
                    inset-2
                    rounded-full
                    bg-[rgb(var(--surface-2))]
                    animate-pulse
                  "
                />
              </div>
            </div>

            {/* Bottom Gradient */}
            <div
              className="
                absolute
                bottom-0
                left-0
                right-0
                h-24
                bg-gradient-to-t
                from-black/30
                to-transparent
              "
            />
          </div>

          {/* Bottom Metadata */}
          <div className="p-3 flex items-center justify-between">
            <div className="flex flex-col gap-2">
              <div
                className="
                  h-3
                  w-24
                  rounded-full
                  bg-[rgb(var(--surface-3))]
                "
              />

              <div
                className="
                  h-2.5
                  w-16
                  rounded-full
                  bg-[rgb(var(--surface-2))]
                "
              />
            </div>

            <div className="flex items-center gap-2">
              <div
                className="
                  h-7
                  w-7
                  rounded-lg
                  bg-[rgb(var(--surface-2))]
                "
              />

              <div
                className="
                  h-7
                  w-7
                  rounded-lg
                  bg-[rgb(var(--surface-2))]
                "
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}